/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable object-curly-newline */

import React from 'react';
import {
    object, bool, number, func, array, shape, string, arrayOf,
} from 'prop-types';
import { connect } from 'react-redux';

import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';

import Form from '../Form';
import { form as FormStyle } from '../../style/form';
import { isEmpty } from '../../utils/object';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import { isArrayIdIncludes } from '../../utils/array';
import InputsByLocation from './AddressConfig/InputsByLocation';
import InputSchema from './AddressConfig/InputSchema';

import Divider from '../Divider';
import PhoneMask from './InputMask/PhoneMask';
import CanadaZipCodeMask from './InputMask/CanadaZipCodeMask';
import configENV from '../../config';
import { countryISOAlfa3Codes } from '../../state/constants/Countries';

const { PERSIST_KEY } = configENV;

const styles = ({ typography, palette }) => FormStyle(typography, palette);

class AddressForm extends Form {
    state = {
        data: {
            firstname: '',
            lastname: '',
            relationship: '0',
            location: 'Residence',
            company: '',
            street: '',
            apt: '',
            apofpo: 'APO',
            city: '',
            state: '',
            zipcode: '',
            country: 'US',
            phone: '',
            isbilling: false,
            suggestedAddress: 0,
        },
        replaceMask: {
            phone: '[\\D]',
            zipcode: '*',
        },
        replaceMaskWith: {
            phone: '',
            zipcode: 'toUpperCase',
        },
        prevLocation: '',
        prevCity: '',
        prevCityAPO: '',
        prevState: '',
        prevStateAPO: '',
        inputConfig: {},
        errors: {},
        modalTitle: '',
        confirmAddress: false,
        selectedSearchAddress: false,
        showSuggestedDropdown: false,
        isVerificationNeeded: true,
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const {
            modal: { title: modalTitle, config },
        } = this.props;
        this.schema = { ...InputSchema[config] };
        const confirmAddress = false;
        const selectedSearchAddress = false;
        const showSuggestedDropdown = false;
        const isVerificationNeeded = true;
        // Initialize state
        this.setState({ inputConfig: InputsByLocation[config], confirmAddress, selectedSearchAddress, showSuggestedDropdown, isVerificationNeeded });
        const {
            AddressId,
            recipient,
            recipient: { Addresses },
            locations,
            relationships,
        } = this.props;
        const { data } = this.state;
        if (config === 'BillingForm') {
            data.isbilling = true;
        }
        if (config === 'GiftListRecipientForm' && !isEmpty(recipient)) {
            const editData = {
                ...recipient.address,
                firstname: recipient.firstname || '',
                lastname: recipient.lastname || '',
                suggestedAddress: 0,
                relationship: 0,
                apofpo: 'APO',
            };
            editData.country = (editData.country) ? editData.country.id : 'US';
            editData.state = (editData.state) ? editData.state.id : '';
            editData.location = (editData.location) ? editData.location.name : 'Residence';
            delete editData.addressId;
            this.setState({ data: editData, modalTitle });
            return;
        }

        if (isEmpty(recipient) || (config !== 'GiftListRecipientForm' && !Addresses) || !this.state.inputConfig || !this.schema) {
            this.setState({ data, modalTitle });
            return;
        }
        const addressesById = Addresses.filter((a) => a.AddressId === AddressId);
        if (!addressesById.length) {
            this.setState({ data, modalTitle });
            return;
        }

        data.firstname = recipient.FirstName;
        data.lastname = recipient.LastName;
        data.relationship = this.getRelationship(
            relationships,
            recipient.RelationShip,
        );
        data.phone = recipient.PhoneNumber ? recipient.PhoneNumber.trim().replace(/[\D]/g, '') : '';
        data.location = isArrayIdIncludes(
            locations,
            addressesById[0].AddressType,
        )
            ? addressesById[0].AddressType
            : 'Residence';
        data.company = recipient.EmployerName ? recipient.EmployerName : '';
        data.street = addressesById[0].AddressLineOne;
        data.apt = addressesById[0].AddressLineTwo;
        data.city = addressesById[0].City;
        data.state = addressesById[0].StateProvince;
        data.zipcode = addressesById[0].PostalCode;
        if (addressesById[0].IsBillingAddress !== undefined) {
            data.isbilling = addressesById[0].IsBillingAddress;
        }
        // TODO: need to default country to US if it's a number value
        data.country = addressesById[0].Country;

        let { prevState, prevStateAPO, prevLocation } = this.state;
        prevLocation = data.location;
        if (data.location === 'APO/FPO') {
            prevStateAPO = data.state;
        } else {
            prevState = data.state;
        }
        data.suggestedAddress = 0;
        this.setState({ data, prevState, prevStateAPO, prevLocation, modalTitle });
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps = (props) => {
        const { modal, selectedAddress, searchResults, isAddressVerification } = props;
        const { selectedSearchAddress, confirmAddress, isVerificationNeeded } = this.state;
        // Reset password fields
        if (!isEmpty(selectedAddress) && selectedSearchAddress) {
            const { data, errors } = this.state;
            data.street = selectedAddress.street;
            data.apt = selectedAddress.apt;
            data.city = selectedAddress.city;
            data.state = selectedAddress.state;
            data.zipcode = selectedAddress.zipcode;
            data.country = selectedAddress.country;
            delete errors.street;
            delete errors.city;
            delete errors.state;
            delete errors.zipcode;
            this.setState({ data, errors, selectedSearchAddress: false }, () => {
                if (!isVerificationNeeded) {
                    this.handleKeepAddressClicked();
                }
            });
            // this.setState({ isSubmited: false, data });
        } else if (isAddressVerification && !confirmAddress && isVerificationNeeded) {
            const hasAddress = this.hasSuggestedAddress(searchResults);
            if (hasAddress) {
                // Keep Address
                this.setState({ isVerificationNeeded: false }, () => {
                    this.handleKeepAddressClicked();
                });
            } else {
                modal.title = 'Address Verification';
                modal.customClass = 'dialog no-x-button';
                this.props.handleUpdateModal(modal);
                this.setState({ confirmAddress: true });
            }
        }
    };

    getRelationship = (relationships, RelationShip) => {
        if (Object.keys(relationships).indexOf(RelationShip) > -1) {
            return RelationShip;
        }
        if (Object.values(relationships).indexOf(RelationShip) > -1) {
            const index = relationships.findIndex(RelationShip);
            return relationships[index].id;
        }
        return '0';
    };

    handleLocationChanged = (dataChanged) => {
        const data = { ...dataChanged };
        let { prevLocation } = this.state;
        const { prevState, prevStateAPO } = this.state;
        if (data.location === 'APO/FPO') {
            data.state = prevStateAPO;
            data.city = data.apofpo;
            const errors = {};
            if (!data.state) {
                errors.state = 'Required field';
            }
            this.setState({ data, errors });
        }
        if (data.location !== 'APO/FPO' && prevLocation === 'APO/FPO') {
            data.city = '';
            data.state = prevState;
            const errors = {};
            errors.city = 'Required field';
            if (!data.state) {
                errors.state = 'Required field';
            }
            this.setState({ data, errors });
        }
        prevLocation = data.location;
        this.setState({ prevLocation });
    };

    handleAPOFPOChanged = (dataChanged) => {
        const data = { ...dataChanged };
        data.city = data.apofpo;
        // data.prevCityAPO = data.city;
        this.setState({ data });
    };

    handleStateChanged = (dataChanged) => {
        const data = { ...dataChanged };
        let { prevState, prevStateAPO } = this.state;
        if (data.location === 'APO/FPO') {
            prevStateAPO = data.state;
        } else {
            prevState = data.state;
        }
        this.setState({ prevState, prevStateAPO });
    };

    handleCountryChanged = (dataChanged) => {
        const data = { ...dataChanged };
        data.location = 'Residence';
        data.state = '';
        data.zipcode = '';
        const errors = {
            state: 'Required field',
            zipcode: 'Required field',
        };
        if (data.city === 'APO' || data.city === '') {
            data.city = '';
            errors.city = 'Required field';
        }
        this.setState({ data, errors });
    };

    hasSuggestedAddress = (newSearchResults) => {
        let isSuggested = true;
        const { data } = this.state;
        const { selectedAddress, searchResults } = this.props;
        if (!isEmpty(selectedAddress)) {
            // Compare every input field with the selectedAddress
            Object.keys(selectedAddress).forEach((item) => {
                if (selectedAddress[item] !== data[item]) {
                    isSuggested = false;
                }
            });
        } else {
            isSuggested = false;
        }
        const fullAddress = this.getFullAddressString();
        const suggestedList = !isEmpty(newSearchResults) ? newSearchResults : searchResults;
        if (!isEmpty(suggestedList)) {
            // Compare full address with the suggestedList
            suggestedList.forEach((item) => {
                if (item.suggestion === fullAddress) {
                    isSuggested = true;
                }
            });
        }
        return isSuggested;
    };

    doSubmit = (submitData) => {
        const {
            modal: { config: templateName },
            recipient: { occasionId: occasionIdRecipient, orderItemId },
            occasionId,
            currentPage,
            recipient,
        } = this.props;
        const { data, confirmAddress, isVerificationNeeded } = this.state;
        const { AddressId, AddressBookEntryId } = submitData;
        const recipientData = {
            addressEntry: {
                FirstName: data.firstname,
                LastName: data.lastname,
                EmployerName: data.company,
                NickName: data.firstname,
                RelationShip: data.relationship,
                PhoneNumber: data.phone ? data.phone : undefined,
            },
            address: {
                AddressType: data.location,
                AddressLineOne: data.street,
                AddressLineTwo: data.apt,
                City: data.city,
                StateProvince: data.state,
                PostalCode: data.zipcode,
                Country: data.country,
                IsBillingAddress: data.isbilling,
            },
        };
        if (!confirmAddress && isVerificationNeeded && !this.hasSuggestedAddress()) {
            // Confirm address layout
            this.verifyAddress();
        } else {
            this.setState({ isVerificationNeeded: false }, () => {
                submitData.handleSubmitAddNewRecipient(
                    recipientData,
                    AddressId,
                    AddressBookEntryId,
                    templateName,
                    (occasionId || occasionIdRecipient),
                    orderItemId,
                    currentPage,
                    recipient,
                );
            });
        }
    };

    getFullAddressString = () => {
        const { data } = this.state;
        let fullAddress = data.street;
        if (data.apt && data.apt.trim()) {
            fullAddress += ` ${data.apt.trim()}, `;
        } else {
            fullAddress += ', ';
        }
        if (data.city && data.city.trim()) {
            fullAddress += `${data.city.trim()} `;
        }
        if (data.state) {
            fullAddress += `${data.state} `;
        }
        if (data.zipcode) {
            fullAddress += data.zipcode;
        }
        return fullAddress;
    };

    verifyAddress = () => {
        const { data } = this.state;
        const isoCountryCode = countryISOAlfa3Codes[data.country];
        const params = {
            query: this.getFullAddressString(),
            country: isoCountryCode,
            take: 20,
        };
        this.props.handleVerifyAddress(params);
    };

    showSuggestions = () => {
        const { data, showSuggestedDropdown } = this.state;
        const { searchResults } = this.props;
        if (!isEmpty(searchResults) && data.street && data.street.length > 3 && showSuggestedDropdown) {
            return (
                <div className="suggested-address-wrapper">
                    <div className="suggested-address">{
                        searchResults.map((address) => (
                            <MenuItem
                                key={address.suggestion}
                                onClick={() => this.handleSelectAnAddress(address)}
                            >
                                {address.suggestion}
                            </MenuItem>
                        ))
                    }
                    </div>
                </div>
            );
        }
        return null;
    }

    handleSelectAnAddress = (address) => {
        this.setState({ selectedSearchAddress: true }, () => {
            this.props.handleSelectAnAddress(address);
        });
    }

    handleStreetKeyPress = (input) => {
        const { data, showSuggestedDropdown } = this.state;
        const street = input.value;
        // Show suggested address when user used tab key
        if (!showSuggestedDropdown) {
            this.setState({ showSuggestedDropdown: true });
        }
        if (street.length > 3 && street.trim()) {
            const isoCountryCode = countryISOAlfa3Codes[data.country];
            const params = {
                query: street,
                country: isoCountryCode,
                take: 25,
            };
            this.props.handleSearchAddress(params);
        }
    };

    hideSuggestedAddress = () => {
        this.setState({ showSuggestedDropdown: false });
    };

    showSuggestedAddress = (input) => {
        const { showSuggestedDropdown } = this.state;
        if (!showSuggestedDropdown) {
            this.setState({ showSuggestedDropdown: true }, () => {
                this.handleStreetKeyPress(input);
            });
        }
    };

    addressFormLayout = () => {
        const { isReadyState, classes, handleSubmitAddNewRecipient } = this.props;
        let { locations } = this.props;
        const {
            AddressId,
            recipient,
            states,
            countries,
            AddressBookEntryId,
        } = this.props;
        const { APOFPO, relationships } = this.props;
        const { data, inputConfig, confirmAddress } = this.state;
        let {
            modal: { title: modalTitle },
        } = this.props;
        let submitButtonLabel = '';
        if (modalTitle) {
            modalTitle = modalTitle.replace(/^(Edit|Add)/, '').trim();
        }
        // if (isEmpty(recipient) || !AddressId) {
        if (isEmpty(recipient)) {
            submitButtonLabel = isReadyState
                ? ''.concat('Add ', modalTitle)
                : 'Adding...';
        } else {
            submitButtonLabel = isReadyState
                ? ''.concat('Save ', modalTitle)
                : 'Saving...';
        }
        let stateByAddressType = states[data.country].filter((s) => s.id !== 'AA' && s.id !== 'AE' && s.id !== 'AP');
        if (data.location === 'APO/FPO' && data.country === 'US') {
            stateByAddressType = states[data.country].filter((s) => s.id === 'AA' || s.id === 'AE' || s.id === 'AP');
        }
        let inputLabels = {};
        if (Object.keys(inputConfig).indexOf(data.location) > -1) {
            inputLabels = inputConfig[data.location];
        } else {
            inputLabels = inputConfig.default;
        }

        const inputLabelsByCountry = {};
        inputLabelsByCountry.state = 'State';
        inputLabelsByCountry.zipcode = 'Zip Code';
        if (data.country !== 'US') {
            inputLabelsByCountry.state = 'Province';
            inputLabelsByCountry.zipcode = 'Postal Code';
        }
        if (data.country === 'CA') {
            locations = locations.filter((l) => l.id !== 'APO/FPO');
        }

        const zipCodeByCountry = {};
        zipCodeByCountry.type = 'tel';
        zipCodeByCountry.regex = '^[0-9\\-]*$';
        zipCodeByCountry.mask = '';
        if (data.country !== 'US') {
            zipCodeByCountry.type = 'text';
            zipCodeByCountry.regex = '^[0-9\\-a-zA-Z\\s]*$';
        }
        if (data.country === 'CA') {
            zipCodeByCountry.mask = CanadaZipCodeMask;
        }

        const submitData = {
            AddressId,
            AddressBookEntryId,
            recipient,
            handleSubmitAddNewRecipient,
        };

        const dataTestPrefix = 'my-account-add-address-';
        return (
            <>
                <form
                    onSubmit={(event) => this.handleSubmit(event, submitData)}
                    className={`${classes.form} ${confirmAddress ? 'display-none' : ''}`}
                >
                    <div className="split">
                        {this.renderInput({
                            name: 'firstname',
                            dataTest: { field: `${dataTestPrefix}${'field-firstname'}`, label: `${dataTestPrefix}${'label-firstname'}` },
                            label: inputLabels.firstname.label,
                            type: 'text',
                            pattern: '^[a-zA-Z\\s\\.\\-&]*$',
                            length: 50,
                            onClickHandler: this.hideSuggestedAddress,
                            minLength: 2,
                        })}
                        {this.renderInput({
                            name: 'lastname',
                            dataTest: { field: `${dataTestPrefix}${'field-lastname'}`, label: `${dataTestPrefix}${'label-lastname'}` },
                            label: inputLabels.lastname.label,
                            type: 'text',
                            pattern: '^[a-zA-Z\\s\\.\\-&]*$',
                            length: 50,
                            onClickHandler: this.hideSuggestedAddress,
                        })}
                    </div>
                    <div className="split">
                        <div className={inputLabels.relationship.class}>
                            {this.renderSelect({
                                name: 'relationship',
                                label: 'Relationship',
                                options: relationships,
                                onClickHandler: this.hideSuggestedAddress,
                            })}
                        </div>
                        <div className={inputLabels.location.class}>
                            {this.renderSelect({
                                name: 'location',
                                label: 'Location Type',
                                options: locations,
                                onChangeHandler: this.handleLocationChanged,
                                onClickHandler: this.hideSuggestedAddress,
                            })}
                        </div>
                    </div>
                    <div className={inputLabels.company.class}>
                        {this.renderInput({
                            name: 'company',
                            dataTest: { field: `${dataTestPrefix}${'field-company'}`, label: `${dataTestPrefix}${'label-company'}` },
                            label: inputLabels.company.label,
                            type: 'text',
                            length: 100,
                            adornment: inputLabels.company.optional ? 'Optional' : '',
                            onClickHandler: this.hideSuggestedAddress,
                        })}
                    </div>
                    {this.renderInput({
                        name: 'street',
                        dataTest: { field: `${dataTestPrefix}${'field-street1'}`, label: `${dataTestPrefix}${'label-street1'}` },
                        label: inputLabels.street.label,
                        type: 'text',
                        length: 100,
                        autoComplete: 'disabled',
                        onKeyupHandler: this.handleStreetKeyPress,
                        onClickHandler: this.showSuggestedAddress,
                        minLength: 2,
                    })}
                    {this.showSuggestions()}
                    {this.renderInput({
                        name: 'apt',
                        label: inputLabels.apt.label,
                        dataTest: { field: `${dataTestPrefix}${'field-street2'}`, label: `${dataTestPrefix}${'label-street2'}` },
                        type: 'text',
                        length: 20,
                        adornment: 'Optional',
                        autoComplete: 'disabled',
                        onClickHandler: this.hideSuggestedAddress,
                    })}
                    <div className="split">
                        <div className={inputLabels.apofpo.class}>
                            {this.renderSelect({
                                name: 'apofpo',
                                label: 'APO/FPO',
                                options: APOFPO,
                                onChangeHandler: this.handleAPOFPOChanged,
                                onClickHandler: this.hideSuggestedAddress,
                            })}
                        </div>
                        <div className={inputLabels.city.class}>
                            {this.renderInput({
                                name: 'city',
                                dataTest: { field: `${dataTestPrefix}${'field-city'}`, label: `${dataTestPrefix}${'label-city'}` },
                                label: inputLabels.city.label,
                                type: 'text',
                                pattern: '^[a-zA-Z\\s\\.\\-]*$',
                                length: 50,
                                autoComplete: 'disabled',
                                onClickHandler: this.hideSuggestedAddress,
                                minLength: 2,
                            })}
                        </div>
                        {this.renderSelect({
                            name: 'state',
                            label: inputLabelsByCountry.state,
                            options: stateByAddressType,
                            onChangeHandler: this.handleStateChanged,
                            useIDAsLabel: true,
                            onClickHandler: this.hideSuggestedAddress,
                        })}
                        {this.renderInput({
                            name: 'zipcode',
                            dataTest: { field: `${dataTestPrefix}${'field-zipcode'}`, label: `${dataTestPrefix}${'label-zipcode'}` },
                            label: inputLabelsByCountry.zipcode,
                            type: zipCodeByCountry.type,
                            pattern: zipCodeByCountry.regex,
                            length: 10,
                            mask: zipCodeByCountry.mask,
                            autoComplete: 'disabled',
                            onClickHandler: this.hideSuggestedAddress,
                        })}
                    </div>
                    {this.renderSelect({
                        name: 'country',
                        label: 'Country',
                        options: countries,
                        onChangeHandler: this.handleCountryChanged,
                        onClickHandler: this.hideSuggestedAddress,
                    })}
                    <div className={inputLabels.phone.class}>
                        {this.renderInput({
                            name: 'phone',
                            dataTest: { field: `${dataTestPrefix}${'field-phone'}`, label: `${dataTestPrefix}${'label-phone'}` },
                            label: inputLabels.phone.label,
                            type: 'tel',
                            pattern: '^[0-9]*$',
                            length: null,
                            adornment: inputLabels.phone.optional ? 'Optional' : '',
                            mask: PhoneMask,
                            onClickHandler: this.hideSuggestedAddress,
                        })}
                    </div>
                    <div className="margin-top-2x">
                        {this.renderButton({
                            label: submitButtonLabel,
                            dataTest: { field: `${dataTestPrefix}${submitButtonLabel.split(' ').join('-').toLowerCase()}` },
                            className: 'buttonHD',
                            onClick: null,
                            type: 'submit',
                        })}
                    </div>
                </form>
            </>
        );
    };

    confirmationLayout = () => {
        const { data, confirmAddress, isVerificationNeeded } = this.state;
        const { searchResults } = this.props;

        if (!confirmAddress) return null;

        const isoCountryCode = countryISOAlfa3Codes[data.country];
        const address = <div className="margin-top-2x margin-bottom-2x"><div>{data.street} {data.apt}</div><div>{data.city}, {data.state} {data.zipcode}</div><div>{isoCountryCode}</div></div>;
        const suggestedList = [];
        if (!isEmpty(searchResults)) {
            searchResults.forEach((item, index) => {
                suggestedList.push({ id: index, name: item.suggestion });
            });
        }
        let textInfo = isEmpty(suggestedList) ? (<p className="bold margin-top">We could not find a match to the address:</p>) : '';
        textInfo = !isVerificationNeeded ? (<p className="bold margin-top">You have selected address:</p>) : textInfo;
        let textOptions = isEmpty(suggestedList) ? (<p className="bold">Please choose one of the options below to proceed</p>) : '';
        textOptions = isVerificationNeeded ? textOptions : '';
        return (
            <>
                <div className={`${!confirmAddress ? 'display-none' : ''}`}>
                    {textInfo}
                    {!isEmpty(suggestedList) ? (
                        <>
                            <p className="margin-bottom-2x">According to the USPS&reg; the street number you entered is either missing or incorrect. Please refer to the list of options below.</p>
                            <p className="h2 no-margin-bottom">Choose Recommended Address Below:</p>
                            <div className="align-center">
                                {this.renderSelect({
                                    name: 'suggestedAddress',
                                    label: '',
                                    options: suggestedList,
                                    onChangeHandler: this.handleLocationChanged,
                                    onClickHandler: this.hideSuggestedAddress,
                                })}
                                <div className="margin-top-2x">
                                    <Button
                                        variant="contained"
                                        className="buttonHD"
                                        onClick={() => this.handleChooseSeletedAddress(searchResults)}
                                    >
                                        Choose Address
                                    </Button>
                                </div>
                            </div>
                            <Divider text="or" />
                            <p className="bold margin-top h2">Keep or edit original address:</p>
                        </>
                    ) : ''}
                    {address}
                    {textOptions}
                    <div className="align-center">
                        <Button
                            variant="contained"
                            className={`buttonHD margin-top ${isVerificationNeeded ? 'margin-bottom-2x' : ''}`}
                            onClick={() => this.handleEditAddressClicked()}
                        >
                            {!isVerificationNeeded ? 'Saving Address...' : 'Edit Address'}
                        </Button>
                        <Button
                            variant="contained"
                            className={`buttonHDSecondary ${!isVerificationNeeded ? 'display-none' : ''}`}
                            onClick={() => this.handleKeepAddressClicked()}
                        >
                            Keep Address
                        </Button>
                    </div>
                </div>
            </>
        );
    };

    handleEditAddressClicked = () => {
        const { modal } = this.props;
        const { modalTitle, data } = this.state;
        modal.title = modalTitle;
        modal.customClass = 'dialog';
        data.suggestedAddress = 0;
        this.props.handleUpdateModal(modal);
        this.props.handleSetVerificationState(false);
        this.setState({ data, confirmAddress: false, isVerificationNeeded: true });
    };

    handleKeepAddressClicked = () => {
        // this.setState({ confirmAddress: false });
        const { AddressId, AddressBookEntryId, recipient, handleSubmitAddNewRecipient } = this.props;
        const { data } = this.state;
        data.suggestedAddress = 0;
        const submitData = {
            AddressId,
            AddressBookEntryId,
            recipient,
            handleSubmitAddNewRecipient,
        };
        this.setState({ data, isVerificationNeeded: false }, () => {
            this.doSubmit(submitData);
        });
    };

    handleChooseSeletedAddress = (searchResults) => {
        const { suggestedAddress } = this.state.data;
        if (!isEmpty(searchResults) && searchResults[suggestedAddress].format) {
            const address = searchResults[suggestedAddress];
            // Get select address and submit data
            this.setState({ isVerificationNeeded: false }, () => {
                this.handleSelectAnAddress(address);
            });
        }
    };

    render() {
        const { inputConfig } = this.state;
        if (!inputConfig) return null;
        return (
            <>
                {this.addressFormLayout()}
                {this.confirmationLayout()}
            </>
        );
    }
}

AddressForm.defaultProps = {
    AddressId: undefined,
    AddressBookEntryId: undefined,
    recipient: {},
    locations: [],
    states: {},
    countries: [],
    APOFPO: [],
    relationships: [],
    selectedAddress: {},
    searchResults: [],
    handleSubmitAddNewRecipient: () => { },
    handleSearchAddress: () => { },
    isAddressVerification: false,
};

AddressForm.propTypes = {
    classes: object.isRequired,
    isReadyState: bool.isRequired,
    AddressId: number,
    AddressBookEntryId: string,
    recipient: shape({
        AddressBookEntryId: string,
        ContactId: number,
        FirstName: string,
        LastName: string,
        NickName: string,
        LastUpdateDate: string,
        NumberOfAddresses: number,
        Addresses: arrayOf(
            shape({
                AddressId: number,
                AddressBookEntryId: string,
                AddressType: string,
                AddressLineOne: string,
                AddressLineTwo: string,
                City: string,
                StateProvince: string,
                PostalCode: string,
                Country: string,
                ContactId: number,
            }),
        ),
    }),
    locations: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ),
    states: shape({
        US: arrayOf(
            shape({
                id: string,
                name: string,
            }),
        ),
        CA: arrayOf(
            shape({
                id: string,
                name: string,
            }),
        ),
    }),
    countries: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ),
    APOFPO: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ),
    relationships: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ),
    selectedAddress: shape({
        street: string,
        apt: string,
        city: string,
        state: string,
        country: string,
        zipcode: string,
    }),
    searchResults: arrayOf(
        shape({
            suggestion: string,
            matched: array,
            format: string,
        }),
    ),
    handleSubmitAddNewRecipient: func,
    handleSearchAddress: func,
    isAddressVerification: bool,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    let selectedAddress = {};
    let searchResults = [];
    let isAddressVerification = false;
    try {
        ({ selectedAddress, searchResults, isAddressVerification } = newState.common.addressVerification);
        // eslint-disable-next-line no-empty
    } catch (ex) { }
    return {
        isReadyState: newState.isReadyState,
        AddressId: newState.AddressId,
        AddressBookEntryId: newState.AddressBookEntryId,
        occasionId: newState.giftList.occasionId,
        recipient: newState.recipient,
        locations: newState.locations,
        states: newState.states,
        countries: newState.countries,
        APOFPO: newState.APOFPO,
        relationships: newState.relationships,
        modal: newState.modal,
        currentPage: newState.giftList.currentPage,
        selectedAddress,
        searchResults,
        isAddressVerification,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleSubmitAddNewRecipient: (data, AddressId, AddressBookEntryId, templateName, occasionId, orderItemId, currentPage, recipient) => dispatch(EventDispatcher.handleSubmitAddNewRecipient(
        data,
        AddressId,
        AddressBookEntryId,
        templateName,
        occasionId,
        orderItemId,
        currentPage,
        recipient,
    )),
    handleSearchAddress: (params) => dispatch(EventDispatcher.handleSearchAddress(params)),
    handleVerifyAddress: (params) => dispatch(EventDispatcher.handleVerifyAddress(params)),
    handleSetVerificationState: (isVerified) => dispatch(EventDispatcher.handleSetVerificationState(isVerified)),
    handleSelectAnAddress: (address) => dispatch(EventDispatcher.handleSelectAnAddress(address)),
    handleUpdateModal: (modal) => dispatch(EventDispatcher.handleUpdateModal(modal)),
    // resetAutoSearch: () => dispatch(EventDispatcher.resetAutoSearch()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(AddressForm));
